var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "#1877F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.3619 50.2557L60.6575 41.8082H52.5525V36.3288C52.5525 34.0171 53.6826 31.7626 57.3128 31.7626H61V24.5708C61 24.5708 57.6553 24 54.4589 24C47.7808 24 43.4201 28.0468 43.4201 35.3699V41.8082H36V50.2557H43.4201V70.6781C44.9098 70.9121 46.4338 71.032 47.9863 71.032C49.5388 71.032 51.0628 70.9121 52.5525 70.6781V50.2557H59.3619Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.64e4e8acdc483f547d0e29229696eb68.svg";
export { ForwardRef as ReactComponent };